const social = [
  {
    social: 'phone',
    url: 'tel:18332957426',
    icon: 'phone'
  },
    {
    social: 'X',
    url: 'https://x.com/cylerian',
    icon: 'X'
  },
  {
    social: 'linkedin',
    url: 'https://www.linkedin.com/company/cylerian',
    icon: 'linkedin'
  },
    {
    social: 'youtube',
    url: 'https://www.youtube.com/@CylerianHQ',
    icon: 'youtube'
  }
];

export default social;

